import React from "react";
import { Link } from "react-router-dom";
import { useTeamSheet } from "../../hooks/sheet.hook";

const TeamBrief = () => {
  const publicUrl = process.env.PUBLIC_URL + "/";
  const team_sheet = useTeamSheet();

  return (
    <section className="team-one">
      <div className="container">
        <div className="section-title text-center">
          <span className="section-title__tagline">Expert Team</span>
          <h2 className="section-title__title">Meet Our Management Team.</h2>
        </div>
        <div className="row">
          {team_sheet.data.map((member, index) => (
            <div
              className={`col-xl-4 col-lg-4 wow fadeIn${
                index % 2 === 0 ? "Left" : "Right"
              }`}
              data-wow-delay={index % 2 === 0 ? "100ms" : "200ms"}
              key={member.name}
            >
              {/* Team One Single */}
              <div className="team-one__single">
                <Link
                  to={`${process.env.PUBLIC_URL}/about/#management-team-${member.id}`}
                >
                  <div
                    className="team-one__img border"
                    style={{
                      background: "#ebebeb",
                      objectFit: "contain",
                      maxWidth: "350px",
                    }}
                  >
                    <img
                      src={`${member.image}`}
                      alt={member.name}
                      style={{ width: "100%", height: "350px", resize: "both" }}
                    />
                  </div>
                </Link>

                <div className="team-one__content">
                  <h4 className="team-one__name">
                    <Link
                      to={`${process.env.PUBLIC_URL}/about/#management-team-${member.id}`}
                    >
                      {member.name}
                    </Link>
                  </h4>
                  <p className="team-one__title">{member.title}</p>
                  <div className="team-one__social d-none">
                    <a href={member.twitter}>
                      <i className="fab fa-twitter"></i>
                    </a>
                    <a href={member.facebook}>
                      <i className="fab fa-facebook"></i>
                    </a>
                    <a href={member.instagram}>
                      <i className="fab fa-instagram"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TeamBrief;
